import * as THREE from 'three';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
export class PlayerView {
    constructor(options) {
        var _a, _b, _c;
        const { scene, camera } = options;
        this.renderer = new THREE.WebGLRenderer({
            antialias: (_a = options.antialias) !== null && _a !== void 0 ? _a : true,
            powerPreference: (_b = options.powerPreference) !== null && _b !== void 0 ? _b : 'high-performance',
            logarithmicDepthBuffer: (_c = options.logarithmicDepthBuffer) !== null && _c !== void 0 ? _c : true,
        });
        this.renderer.setSize(window.innerWidth, window.innerHeight, false);
        this.renderer.domElement.tabIndex = 0;
        this.renderer.domElement.style.touchAction = 'none';
        this.composer = new EffectComposer(this.renderer);
        this.renderPass = new RenderPass(scene, camera);
        this.composer.addPass(this.renderPass);
        this.outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), scene, camera);
        this.composer.addPass(this.outlinePass);
    }
    mount(parent) {
        if (!this.renderer.domElement.parentElement) {
            parent.appendChild(this.renderer.domElement);
        }
    }
    setScene(scene) {
        this.renderPass.scene = scene;
        this.outlinePass.renderScene = scene;
        this.outlinePass.selectedObjects = [];
    }
    dispose() {
        if (this.renderer.domElement.parentElement) {
            this.renderer.domElement.parentElement.removeChild(this.renderer.domElement);
        }
        this.composer.dispose();
        this.renderer.dispose();
    }
}
